import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { differenceInMonths } from 'date-fns';
import { NotificationName } from 'utils/constants/notification';
import { Permissions } from 'utils/constants/permissions';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import {
    InvoiceFilterType,
    setAccountsByInvoices,
    setInvoices,
    setLoad,
    setShowGiftButton,
} from 'store/models/invoices';
import { addNotification } from 'store/models/notification';

const MAX_PERIOD_IN_MONTHS = 24;

export default (from, to, filterType, filterValue, disableUrlSync = false) => {
    return (dispatch, getState) => {
        const state = getState();
        const user = state.user;
        dispatch(setLoad(true));
        const params = {
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        };
        if (filterValue || filterType === InvoiceFilterType.Manual) {
            params.type = filterType;
            params.value = filterValue;
        } else if (differenceInMonths(to, from) > MAX_PERIOD_IN_MONTHS) {
            dispatch([setLoad(false), addNotification(NotificationName.InvoicesPageErrorMaxPeriod)]);
            return null;
        }
        const queryStr = urlParser.stringify(params);
        if (!disableUrlSync) {
            dispatch(push({ search: queryStr }, undefined, { cancelFetchingData: true }));
        }
        return fetcher
            .get(`/api/v1/backoffice/invoices/with_accounts?${queryStr}`)
            .then(({ invoices, accounts }) => {
                dispatch([
                    setLoad(false),
                    setInvoices(invoices),
                    setAccountsByInvoices(accounts),
                    setShowGiftButton(
                        filterType === InvoiceFilterType.AccountId &&
                            filterValue > 0 &&
                            user.permissions.includes(Permissions.ViewAdminBonusForm)
                    ),
                ]);
            })
            .catch(() => {
                dispatch([setLoad(false), addNotification(NotificationName.InvoicesPageError)]);
            });
    };
};
